<script setup lang="ts">
import { ref } from 'vue'

const activeNames = ref([])
const open = defineModel<boolean>()

const handleClose = () => {
  activeNames.value = []
}
</script>

<template>
  <el-dialog v-model="open" :width="600" title="Frequently Asked Questions" :show-close="false" @close="handleClose">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="What are teams?" name="1">
        <div>
          Teams are a way to share resources between users. Team members can access and manage resources from other
          members.
        </div>
      </el-collapse-item>
      <el-collapse-item title="Who can be added to a team?" name="2">
        <div>Team owner can add anyone to the team as long as they know the email they used to register.</div>
      </el-collapse-item>
      <el-collapse-item title="What can team members see?" name="3">
        <div>
          Team members share resources. Any resource that belongs to you will be accessible by other team members and
          vice versa.
        </div>
      </el-collapse-item>
      <el-collapse-item title="What happens if the team is deleted?" name="4">
        <div>
          The team will cease to exist and any current team members will be kicked out of it. You can always create a
          new team at any time or get invited to one.
        </div>
      </el-collapse-item>
      <el-collapse-item title="Can I be part of multiple teams?" name="5">
        <div>No. You can only belong to a single team, either by being its owner or just a member.</div>
      </el-collapse-item>
    </el-collapse>
  </el-dialog>
</template>
